export default __webpack_public_path__ + "static/media/o2.70948985.svg";